module.exports = __webpack_public_path__ + "img/user4.c1758e19.png";